"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLanguageContext = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LANGUAGES = _interopRequireDefault(require("../constants/lang/LANGUAGES"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var defaultValue = {
  language: 'ar',
  isArabic: true,
  isRtl: true
};
var Context = (0, _react.createContext)(defaultValue);
var ContextProvider = function ContextProvider(_ref) {
  var children = _ref.children,
    language = _ref.language;
  var isArabic = language === _LANGUAGES["default"].AR;
  var value = (0, _react.useMemo)(function () {
    return {
      language: language,
      isArabic: isArabic,
      isRtl: !!isArabic
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [language]);
  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
    value: value
  }, children);
};
var _default = exports["default"] = ContextProvider;
var useLanguageContext = exports.useLanguageContext = function useLanguageContext() {
  var context = (0, _react.useContext)(Context);
  if (!context) {
    throw new Error('Language context must be used within a Language Provider');
  }
  return context;
};